import { render, staticRenderFns } from "./orderConsumption.vue?vue&type=template&id=11fabf00&scoped=true"
import script from "./orderConsumption.vue?vue&type=script&lang=js"
export * from "./orderConsumption.vue?vue&type=script&lang=js"
import style0 from "./orderConsumption.vue?vue&type=style&index=0&id=11fabf00&prod&lang=scss&scoped=true"
import style1 from "./orderConsumption.vue?vue&type=style&index=1&id=11fabf00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fabf00",
  null
  
)

export default component.exports